import React from "react";

export default function KataSkeleton() {
  return (
    <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white dark:border-white/10 dark:bg-slate-900"
        >
          <div className="h-48 animate-pulse bg-slate-200 dark:bg-white/10" />

          <div className="space-y-4 p-5">
            <div className="h-5 w-2/3 animate-pulse rounded bg-slate-200 dark:bg-white/10" />
            <div className="h-4 w-full animate-pulse rounded bg-slate-200 dark:bg-white/10" />
            <div className="h-4 w-5/6 animate-pulse rounded bg-slate-200 dark:bg-white/10" />
            <div className="h-12 w-full animate-pulse rounded-xl bg-slate-200 dark:bg-white/10" />
          </div>
        </div>
      ))}
    </div>
  );
}